// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/box-list/pickup-switching.css
// module id = 13580
// module chunks = 0